// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"639":"9030bb4e","908":"38b35738","981":"63272b1a"}[chunkId] + ".chunk.css";
};